import React from "react";
import { Modal } from "antd";
import LoadableButton from "../button/LoadableButton";

const ConfirmationModal = ({
  isOpen = false,
  setIsOpen,
  width,
  type,
  message,
  onConfirm,
  isLoading,
  loadingLabel = "Loading...",
}) => {
  return (
    <Modal
      open={isOpen}
      closeIcon={false}
      footer={false}
      maskClosable={false}
      keyboard={false}
      width={width}
    >
      <div className="lg:pb-1">
        <div className="md:p-6 p-3">
          <div className="flex justify-center mt-4">
            <img
              src={`/assets/icons/${
                type === "success" ? "success-icon.svg" : "warning-icon.svg"
              }`}
              alt="icon"
              className="md:w-20 w-14"
              // width={80}
            />
          </div>

          <p className="title text-center mt-4 md:mt-8">{message}</p>

          <div className="flex justify-center items-center md:gap-5 gap-3 mt-4 md:mt-8">
            <LoadableButton
              lable="No"
              className="!bg-[#D91819] hover:!bg-[#aa0001]"
              onClick={() => setIsOpen(false)}
              disabled={isLoading}
            />
            <LoadableButton
              lable="Yes"
              className="!bg-[#2D9B63] hover:!bg-[#096034]"
              isLoading={isLoading}
              loadingLable={loadingLabel}
              onClick={() => onConfirm()}
              disabled={isLoading}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
